<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22.311" height="22.121" viewBox="0 0 22.311 22.121" class="edit-icon">
    <g transform="translate(-815 -326)">
      <path class="a" d="M11,4H4A2,2,0,0,0,2,6V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V13"
            transform="translate(814 325.121)"/>
      <path class="a" d="M18.5,2.5a2.121,2.121,0,0,1,3,3L12,15,8,16l1-4Z" transform="translate(814 325.121)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'EditIcon'
}
</script>

<style scoped>
svg .a {
  fill: none;
  stroke: #8ea2a8;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
